import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLoader } from '../../../../context/LoaderProvider.jsx';
import {
    getAllCateringSettlementsAPI,
    approveSettlementAPI,
    generateSettlementRangeAPI,
} from "../../../Servicefile/CateringSettlementService.jsx";
const CateringSettelment = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [year, setYear] = useState("");
    const [month, setMonth] = useState("");
    const [selectedDate, setSelectedDate] = useState("");
    const [invoiceData, setInvoiceData] = useState([]);
    const { showLoader, hideLoader } = useLoader();
    const [settlements, setSettlements] = useState([]);
    const [filteredSettlements, setFilteredSettlements] = useState([]);
    const [error, setError] = useState(null);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");


    // ✅ Function to approve settlement
    const handleApprove = async (
        settlementId
    ) => {
        try {
            await approveSettlementAPI(
                settlementId
            );

            alert(
                "✅ Settlement approved successfully!"
            );

            // refresh data if needed
            // fetchSettlements();

        } catch (error) {
            console.error(
                "❌ Error approving settlement:",
                error
            );

            let errorMsg =
                "❌ Failed to approve settlement.";

            if (error.response) {
                errorMsg +=
                    `\nStatus: ${error.response.status}\nMessage: ${error.response.data
                        ?.message ||
                    "Unknown server error"
                    }`;

            } else if (
                error.request
            ) {
                errorMsg +=
                    "\nNo response received from server.";

            } else {
                errorMsg +=
                    `\nError: ${error.message}`;
            }

            alert(errorMsg);
        }
    };

    const handleSend = async () => {
        if (
            !fromDate ||
            !toDate
        ) {
            alert(
                "⚠️ Please select both From and To dates"
            );

            return;
        }

        try {
            await generateSettlementRangeAPI(
                fromDate,
                toDate
            );

            alert(
                "✅ Data generated successfully!"
            );

        } catch (error) {
            console.error(
                "❌ Error generating range:",
                error
            );

            alert(
                "❌ Failed to generate data. Check console for details."
            );
        }
    };



    // ✅ Fetch Settlements from API with Token
    // ✅ Fetch Settlements from API with Token
    useEffect(() => {
        const fetchSettlements =
            async () => {
                try {
                    showLoader();

                    const data =
                        await getAllCateringSettlementsAPI();

                    setSettlements(
                        data
                    );

                    setFilteredSettlements(
                        data
                    );

                } catch (error) {
                    console.error(
                        "❌ Error fetching settlements:",
                        error
                    );

                    setError(
                        "Error fetching settlements. See console."
                    );

                } finally {
                    hideLoader();
                }
            };

        fetchSettlements();

    }, []);


    useEffect(() => {
        let filtered = [...settlements];

        if (searchTerm) {
            filtered = filtered.filter((item) =>
                item.vendorId.toString().includes(searchTerm)
            );
        }

        if (year) {
            filtered = filtered.filter(
                (item) => new Date(item.settlementDate).getFullYear() === Number(year)
            );
        }

        if (month) {
            filtered = filtered.filter(
                (item) => new Date(item.settlementDate).getMonth() === Number(month)
            );
        }

        if (selectedDate) {
            filtered = filtered.filter(
                (item) => new Date(item.settlementDate).getDate() === Number(selectedDate)
            );
        }

        setFilteredSettlements(filtered);
    }, [searchTerm, year, month, selectedDate, settlements]);




    // ✅ Handle year/month/day dropdown
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: currentYear - 2024 + 1 }, (_, i) => 2024 + i);
    const monthsLabel = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    const [daysInMonth, setDaysInMonth] = useState([]);

    useEffect(() => {
        const y = year ? Number(year) : currentYear;
        const m = month !== "" ? Number(month) : new Date().getMonth();
        const days = new Date(y, m + 1, 0).getDate();
        setDaysInMonth(Array.from({ length: days }, (_, i) => i + 1));
        if (selectedDate && (selectedDate < 1 || selectedDate > days)) {
            setSelectedDate("");
        }
    }, [year, month, selectedDate]);



    // ✅ Export CSV
    const handleExport = () => {
        // Headers for CSV (match table columns)
        const headers = [
            "Vendor ID",
            "Total Cgst",
            "Grand Total",
            "Total Sales",
            "Service Charges",
            "To Settle",
            "Admin Acc",
            "Vendor Name",
            "Vendor Acc",
            "IFSC",
            "Settlement Date",
            "Payment Status"
        ];

        // Rows of CSV
        const rows = filteredSettlements.map((it) => [
            it.vendorId,
            it.totalCgst,
            it.totalGrandTotal,
            it.totalAmountBeforeTds,
            it.tdsAmount,
            it.amountAfterTds,
            it.superadminAccNo,
            it.holderName,
            it.accountNumber,
            it.ifscCode,
            it.settlementDate,
            it.paymentStatus === "SUCCESS" ? "Approved" : "Pending" // replace action button with status
        ]);

        // Convert to CSV string
        const csvContent = [headers, ...rows].map((r) => r.join(",")).join("\n");

        // Download CSV
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "settlements.csv";
        link.click();

        // console.log("✅ CSV exported successfully");
    };


    const tableHeaderStyle = {
        border: "1px solid #ddd",
        textAlign: "center",
        fontWeight: "bold",
        backgroundColor: "rgb(230 109 51)",
        color: "white",
        padding: 6,
    };
    const tableCellStyle = {
        border: "1px solid #ddd",
        textAlign: "center",
        padding: 6,
    };

    return (
        <div style={{}}>
            {error && (
                <p style={{ color: "red", fontWeight: "bold", marginBottom: 10 }}>
                    {error}
                </p>
            )}

            {/* Filters + Export */}
            <div
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 10,
                    marginTop: 10,
                    gap: 10,
                }}
            >
                <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                    <input
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        placeholder="Search by Vendor ID"
                        style={{ padding: 6, width: 180, borderRadius: "10px" }}
                    />

                    {/* <select value={year} onChange={(e) => setYear(e.target.value)} style={{ padding: 6, borderRadius: "10px" }}>
                        <option value="">Year</option>
                        {years.map((y) => <option key={y} value={y}>{y}</option>)}
                    </select>
                    <select value={month} onChange={(e) => setMonth(e.target.value)} style={{ padding: 6, borderRadius: "10px" }}>
                        <option value="">Month</option>
                        {monthsLabel.map((m, i) => <option key={i} value={i}>{m}</option>)}
                    </select>
                    <select value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)} style={{ padding: 6, borderRadius: "10px" }}>
                        <option value="">Date</option>
                        {daysInMonth.map((d) => <option key={d} value={d}>{d}</option>)}
                    </select> */}

                    <input
                        type="date"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                        style={{ padding: 6, borderRadius: "10px" }}
                    />
                    <span style={{ marginTop: "10px" }}>to</span>
                    <input
                        type="date"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                        style={{ padding: 6, borderRadius: "10px" }}
                    />
                    <button
                        onClick={handleSend}
                        style={{
                            backgroundColor: "#007bff",
                            color: "white",
                            border: "none",
                            borderRadius: "10px",
                            padding: "6px 15px",
                            cursor: "pointer",
                        }}
                    >
                        Send
                    </button>
                </div>

                <button
                    onClick={handleExport}
                    style={{
                        padding: "6px 12px",
                        backgroundColor: "rgb(230 109 51)",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        cursor: "pointer",
                    }}
                >
                    Export CSV
                </button>
            </div>

            {/* Table */}
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                    <tr>
                        <th style={tableHeaderStyle}>Vendor ID</th>
                        <th style={tableHeaderStyle}>Total Cgst</th>
                        <th style={tableHeaderStyle}>Grand Total</th>
                        <th style={tableHeaderStyle}>Total Sales</th>
                        <th style={tableHeaderStyle}>Service Charges</th>
                        <th style={tableHeaderStyle}>To Settle</th>
                        <th style={tableHeaderStyle}>Admin Acc</th>
                        <th style={tableHeaderStyle}>Vendor Name</th>
                        <th style={tableHeaderStyle}>Vendor Acc</th>
                        <th style={tableHeaderStyle}>IFSC</th>

                        <th style={tableHeaderStyle}>Settlement Date</th>
                        <th style={tableHeaderStyle}>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredSettlements.length > 0 ? (
                        filteredSettlements.map((it) => (
                            <tr key={it.adminId}>
                                <td style={tableCellStyle}>{it.vendorId}</td>
                                <td style={tableCellStyle}>{it.totalCgst}</td>
                                <td style={tableCellStyle}>{it.totalGrandTotal}</td>
                                <td style={tableCellStyle}>₹{it.totalAmountBeforeTds}</td>
                                <td style={tableCellStyle}>-₹{it.tdsAmount}</td>
                                <td style={tableCellStyle}>{it.amountAfterTds}</td>
                                <td style={tableCellStyle}>{it.superadminAccNo}</td>
                                <td style={tableCellStyle}>{it.holderName}</td>
                                <td style={tableCellStyle}>{it.accountNumber}</td>
                                <td style={tableCellStyle}>{it.ifscCode}</td>
                                <td style={tableCellStyle}>{it.settlementDate}</td>

                                {/* ✅ Action Column */}
                                <td style={tableCellStyle}>
                                    {it.paymentStatus === "SUCCESS" ? (
                                        <button
                                            disabled
                                            style={{
                                                padding: "6px 12px",
                                                backgroundColor: "#9e9e9e", // gray for approved
                                                color: "#fff",
                                                border: "none",
                                                borderRadius: "5px",
                                                cursor: "not-allowed",
                                            }}
                                        >
                                            Approved
                                        </button>
                                    ) : (
                                        <button
                                            onClick={() => handleApprove(it.settlementId)}
                                            style={{
                                                padding: "6px 12px",
                                                backgroundColor: "#4caf50",
                                                color: "#fff",
                                                border: "none",
                                                borderRadius: "5px",
                                                cursor: "pointer",
                                            }}
                                        >
                                            Approve
                                        </button>
                                    )}
                                </td>


                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="12" style={{ textAlign: "center", padding: "10px" }}>
                                No settlement data found.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>


        </div>
    );
};

export default CateringSettelment;
